export default __webpack_public_path__ + "static/media/popup-spinner.1b27cd7a.svg";